import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent, CardContentComponent, CardHeaderComponent, HelpPopoverComponent } from '@nk/ui-lib';
import { CompanyAnalysisNetworkRiskScoreComponent } from '../company-analysis-network-risk-score/company-analysis-network-risk-score.component';

@Component({
  selector: 'nk-company-analysis-network-risk-card',
  imports: [
    TranslateModule,
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    HelpPopoverComponent,
    CompanyAnalysisNetworkRiskScoreComponent,
  ],
  templateUrl: './company-analysis-network-risk-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisNetworkRiskCardComponent {
  public companyIdentifier = input.required<string>();
  public defaultListSize = input(3);
  public displayShowMoreButton = input(true);
  public printVersion = input(false);
}
